export const withTimeout = <T>(promise: Promise<T>, timeout: number): Promise<T | 'timeout'> => {
  const timeoutPromise = new Promise<'timeout'>((resolve) => {
    setTimeout(() => resolve('timeout'), timeout);
  });

  return Promise.race([promise, timeoutPromise]);
};
